import { z } from 'zod/v4';

// Enums / literal unions
export const ControlMode = z.enum(['NO_CONTROL', 'CONTAINER', 'REDIS']); // 'NO_CONTROL' | 'CONTAINER' | 'REDIS'
export type ControlMode = z.infer<typeof ControlMode>;

export const UpdateMethod = z.enum(['ENDPOINT', 'COMMAND', 'RESTART']); // 'ENDPOINT' | 'COMMAND' | 'RESTART'
export type UpdateMethod = z.infer<typeof UpdateMethod>;

export const UrlMethod = z.enum(['GET', 'POST']); // 'GET' | 'POST'
export type UrlMethod = z.infer<typeof UrlMethod>;

export const ReqMethod = z.enum([
  'get',
  'post',
  'put',
  'patch',
  'delete',
  'head',
  'options',
]); // adjust to your actual ReqMethod
export type ReqMethod = z.infer<typeof ReqMethod>;

export const ExporterDTO = z.object({
  name: z.string(),
  label: z.string(),
  config: z.string(),
  control_mode: ControlMode,
  redis: z.object({
    key: z.string(),
  }),
  container: z.object({
    docker_url: z.string(),
    container_id: z.string(),
    config_path: z.string(),
    update_method: UpdateMethod,
    url: z.string(),
    url_method: UrlMethod,
    command: z.string(),
  }),
  doc_url: z.string(),
  tags: z.array(z.string()),
});
export type Exporter = z.infer<typeof ExporterDTO>;

// ExportersStorage
export const ExportersStorageDTO = z.object({
  name: z.string(),
  label: z.string(),
  config: z.string(),
  control_mode: ControlMode,
});
export type ExportersStorage = z.infer<typeof ExportersStorageDTO>;

// ExporterCreateRequest
export const ExporterCreateRequestDTO = z.object({
  name: z.string(),
  control_mode: ControlMode,
  key: z.string().optional(),
  config: z.string(),
  url: z.string().default('localhost').optional(),
  method: ReqMethod.default('get').optional(),
});
export type ExporterCreateRequest = z.infer<typeof ExporterCreateRequestDTO>;

// ExporterFileResponse
export const ExporterFileDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  content: z.string(),
});
export type ExporterFile = z.infer<typeof ExporterFileDTO>;

// ExporterInfoResponse
export const ExporterInfoDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  key: z.string(),
  config: z.string(),
  url: z.string(),
  method: ReqMethod,
});
export type ExporterInfo = z.infer<typeof ExporterInfoDTO>;

// ExporterResponse
export const ExporterBriefDTO = z.object({
  name: z.string(),
  label: z.string(),
  control_mode: ControlMode,
  doc_url: z.string().nullable(),
  tags: z.array(z.string()),
});
export type ExporterBrief = z.infer<typeof ExporterBriefDTO>;

// ExporterUpdateRequest
export const ExporterUpdateRequestDTO = z.object({
  config: z.string(),
  url: z.string().default('').optional(),
  method: ReqMethod.optional(),
});
export type ExporterUpdateRequest = z.infer<typeof ExporterUpdateRequestDTO>;